import { logError } from "services/logging";

export default function assert(condition: any, message: string): asserts condition {
  if (!condition) {
    const errorMsg = `ASSERTION FAILED: ${message}`;
    if (import.meta.env.PROD) {
      logError(errorMsg);
    } else {
      throw new Error(errorMsg);
    }
  }
}
